import { createSlice } from "@reduxjs/toolkit";

export enum Modals {
    filter = "filter",
    are_you_sure = "are_you_sure",
    add_params = "add_params",
    ticker_picker = "ticker_picker",
    formula = "formula",
    ui_block_full = "ui_block_full",
    colors_picker = 'colors_picker',
    tickers_commands = 'tickers_commands',
    size_settings = "size_settings"
}

export type Modal = keyof typeof Modals;

export type ModalState = {
    [key in Modals]?: boolean;
};

export interface IModalState {
    modals: ModalState;
    caller: string | number | undefined;
    opened: Modal[];
    args: any;
}

const initialState: IModalState = {
    modals: {
        filter: false,
        are_you_sure: false,
        add_params: false,
        ticker_picker: false,
        formula: false,
        ui_block_full: false,
        colors_picker: false,
        tickers_commands: false
    },
    opened: [],
    args: {},
    caller: undefined,
};

const _modals = Object.keys(Modals);

const modal = createSlice({
    name: "modal",
    initialState,
    reducers: {
        showModal(state, action) {
            const { modal_type, value, caller, args } = action.payload;
            for (const _modal of _modals) {
                if (modal_type === _modal) {
                    state.modals[_modal] = value;
                    if (args) {
                        state.args = args;
                    }
                    continue;
                }
                state.modals[_modal] = false;
            }

            if (typeof caller === "number" || typeof caller === "string") {
                state.caller = caller;
            }

            if (value === true) {
                state.opened.push(modal_type);
            } else {
                state.opened.pop();
                const last_modal = state.opened[state.opened.length - 1];
                //state.caller = undefined;
                state.args = undefined;
                if (last_modal) {
                    state.modals[last_modal] = true;
                }
                if (!last_modal) {
                    state.caller = undefined;
                }
            }
        },
    },
});

export const { showModal } = modal.actions;

export default modal.reducer;
